import { isUndefined } from 'lodash-es';
import { patchStorage, getStorage } from '../local-storage';
/**
 * AJV will compile a combined standalone validator for all schemas in the
 * schemas folder. The current implementation only validates trade-in and
 * is the 'default' export, but if multiple schemas need to be validated,
 * reference the schema by its $id property. For exmaple:
 *  require('../compiled-validators/validate').tradeIn
 * or
 *  require('../compiled-validators/validate')['http://example/schema.json']
 */
const tradeInValidator = require('../compiled-validators/validators').tradeIn;
export var Condition;
(function (Condition) {
    Condition["High"] = "high";
    Condition["Low"] = "low";
    Condition["Target"] = "target";
})(Condition || (Condition = {}));
/**
 * Ingests a trade in and persists it to local storage for future retrieval.
 * Validates the data against the `TradeIn` schema, will throw an error if
 * the data provided is invalid or if it is unable to save.
 */
export async function ingestTradeIn(data) {
    const isValid = tradeInValidator(data);
    if (!isValid) {
        console.error(`DI CCDP :: IngestTradeIn validation failure; ${JSON.stringify(tradeInValidator.errors)}`);
        throw new Error('DI CCDP :: IngestTradeIn validation failure');
    }
    patchStorage({ tradeIn: data });
}
/**
 * Retrieves the last Trade In from localStorage.
 * Will return an empty object if no Trade In was found.
 *
 */
export async function egressLastTradeIn() {
    const storage = getStorage();
    if (!isUndefined(storage.tradeIn)) {
        return storage.tradeIn;
    }
    return {};
}
